namespace $ {

	export function $shm_projects_task_create( project_id: string ) {
		const tasks = [ ... $shm_projects_tasks_list( project_id ) ]
		const number = tasks.reduce( ( maximum, task )=> Math.max( maximum, Number( task.title.match( /^Задача (\d+)$/ )?.[1] || 0 ) ), 0 ) + 1
		const now = Date.now()
		const task: $shm_projects_task_record = {
			id: `${ now.toString( 36 ) }-${ Math.random().toString( 36 ).slice( 2, 10 ) }`,
			project_id,
			title: `Задача ${ number }`,
			description: '',
			result: '',
			run_id: '',
			status: 'draft',
			created_at: now,
			updated_at: now,
		}
		$mol_state_local.value( `$shm_projects_tasks(${ project_id })`, [ task, ... tasks ] )
		return task
	}

}
